import React, { useState } from 'react';
import TextInput from '../ui/inputs/TextInput';
import ValidationMessage from '../ui/ValidationMessage';
import IconInvoiceTrash from '../../images/icons/Invoice/invoice-trash.svg';
import PrimaryButton from '../ui/buttons/PrimaryButton';
import Plus from '../../images/icons/customSvg/plus';
import { invoiceInputBackgroundColor, defaultValidationMessage, multiplyNumbers } from '../../helper/helpers';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as userActions from './reduxStore/action';

import XXSText from '../ui/typography/XXSText';
function InvoiceGoods({ invoiceData, register, errors, selectedCurrency, getInvoiceDetails, isFinalize }) {
  const [formValues, setFormValues] = useState(
    getInvoiceDetails?.invoiceItems
      ? getInvoiceDetails?.invoiceItems
      : [{ itemTitle: '', itemDescription: '', itemQuantity: '', itemPrice: '', itemTotal: '' }]
  );

  let handleChange = (index, event, name) => {
    let newFormValues = [...formValues];
    newFormValues[index][name] = event.target.value;
    if (formValues[index]['itemQuantity'] && formValues[index]['itemPrice']) {
      newFormValues[index]['itemTotal'] = String(
        multiplyNumbers([formValues[index]['itemQuantity'], formValues[index]['itemPrice']])
      );
    } else {
      newFormValues[index]['itemTotal'] = '';
    }
    setFormValues(newFormValues);
    invoiceData({ invoiceItems: newFormValues });
  };

  let addFormFields = () => {
    setFormValues([
      ...formValues,
      { itemTitle: '', itemDescription: '', itemQuantity: '', itemPrice: '', itemTotal: '' }
    ]);
  };

  let removeFormFields = (index) => {
    let newFormValues = [...formValues];
    newFormValues.splice(index, 1);
    setFormValues(newFormValues);
    invoiceData({ invoiceItems: newFormValues });
  };

  return (
    <div>
      <XXSText className="my-6" textColor="text-gray-600" title="Description of goods" />
      {formValues.map((element, index) => (
        <div className="flex md:flex-row flex-col gap-4 mt-3 invoice-right-padding" key={index}>
          <TextInput
            textFieldContainerClass="invoice-items-and-task-title"
            name={`itemTitle${index}`}
            label="Item"
            variant="filled"
            defaultValue={element?.itemTitle || ''}
            onChange={(event) => handleChange(index, event, 'itemTitle')}
            backgroundColor={invoiceInputBackgroundColor(element?.itemTitle)}
            inputRef={register({
              required: isFinalize
            })}
            error={errors?.[`itemTitle${index}`] ? true : false}
            helperText={
              errors?.[`itemTitle${index}`] && <ValidationMessage title={defaultValidationMessage('Goods details')} />
            }
          />

          <TextInput
            textFieldContainerClass="invoice-items-and-task-description"
            name={`itemDescription${index}`}
            label="Description"
            variant="filled"
            value={element?.itemDescription || ''}
            onChange={(e) => handleChange(index, e, 'itemDescription')}
            backgroundColor={invoiceInputBackgroundColor(element?.itemDescription)}
            inputRef={register({
              required: false
            })}
          />
          <div className="flex flex-col md:flex-row  gap-4">
            <TextInput
              textFieldContainerClass="invoice-items-price-and-task-rate"
              name={`itemPrice${index}`}
              label="Price"
              variant="filled"
              type="number"
              value={element?.itemPrice || ''}
              startAdornment={
                element?.itemPrice
                  ? selectedCurrency?.symbol
                    ? selectedCurrency?.symbol
                    : selectedCurrency?.name
                  : null
              }
              onChange={(e) => handleChange(index, e, 'itemPrice')}
              backgroundColor={invoiceInputBackgroundColor(element?.itemPrice)}
              inputRef={register({
                required: isFinalize
              })}
              error={errors?.[`itemPrice${index}`] ? true : false}
            />
            <TextInput
              textFieldContainerClass="invoice-items-quantity-and-task-hour"
              name={`itemQuantity${index}`}
              label="Qty"
              variant="filled"
              type="number"
              value={element?.itemQuantity || ''}
              onChange={(e) => handleChange(index, e, 'itemQuantity')}
              backgroundColor={invoiceInputBackgroundColor(element?.itemQuantity)}
              inputRef={register({
                required: isFinalize
              })}
              error={errors?.[`itemQuantity${index}`] ? true : false}
            />
            <div className="flex self-start w-full md:w-auto items-center">
              <TextInput
                textFieldContainerClass="invoice-items-and-task-total"
                name={`itemTotal${index}`}
                label="Total"
                variant="filled"
                value={
                  element?.itemQuantity &&
                  element?.itemPrice &&
                  multiplyNumbers([element?.itemQuantity, element?.itemPrice])
                }
                startAdornment={
                  multiplyNumbers([element?.itemQuantity, element?.itemPrice])
                    ? selectedCurrency?.symbol
                      ? selectedCurrency?.symbol
                      : selectedCurrency?.name
                    : null
                }
                backgroundColor={invoiceInputBackgroundColor(
                  multiplyNumbers([element?.itemQuantity, element?.itemPrice])
                )}
                inputRef={register({
                  required: false
                })}
              />
              {formValues?.length > 1 && (
                <img
                  onClick={() => removeFormFields(index)}
                  src={IconInvoiceTrash}
                  alt="IconInvoiceTrash"
                  className="cursor-pointer -mr-10 pl-2 md:pl-5"
                />
              )}
            </div>
          </div>
        </div>
      ))}
      <PrimaryButton
        id="invoice-goods-add-btn"
        className="invoice-button mt-4"
        bgColor="bg-coral-500"
        textColor="text-white"
        onClick={() => addFormFields()}
        caption={
          <div className="flex gap-2 text-medium items-center">
            <Plus />
            Add good
          </div>
        }
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    getInvoiceDetails: state?.invoiceDetails?.invoiceData
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    invoiceData: (invoiceData) => dispatch(userActions.invoiceData(invoiceData))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceGoods);

InvoiceGoods.propTypes = {
  getInvoiceDetails: PropTypes.object,
  invoiceData: PropTypes.func
};
